var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNewsFeed = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/keyboard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "keyboard"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.2487 3.33301H13.7487C14.2654 3.33301 14.7237 3.34967 15.132 3.40801C17.3237 3.64967 17.9154 4.68301 17.9154 7.49967V12.4997C17.9154 15.3163 17.3237 16.3497 15.132 16.5913C14.7237 16.6497 14.2654 16.6663 13.7487 16.6663H6.2487C5.73203 16.6663 5.2737 16.6497 4.86536 16.5913C2.6737 16.3497 2.08203 15.3163 2.08203 12.4997V7.49967C2.08203 4.68301 2.6737 3.64967 4.86536 3.40801C5.2737 3.34967 5.73203 3.33301 6.2487 3.33301Z",
    stroke: "#7E7E80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.25 8.33301H14.1667",
    stroke: "#7E7E80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.83203 12.917H5.8487H14.1654",
    stroke: "#7E7E80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.41209 8.33366H8.41957",
    stroke: "#7E7E80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.91209 8.33366H5.91957",
    stroke: "#7E7E80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewsFeed, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/news-feed.14510426.svg";
export { ForwardRef as ReactComponent };